import { render, staticRenderFns } from "./CardHighlightV2.vue?vue&type=template&id=4a962a05&"
import script from "./CardHighlightV2.vue?vue&type=script&lang=js&"
export * from "./CardHighlightV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports